(function () {
    function activateTab(tabLink) {
        var group = tabLink.closest(".panel-group--tabs");
        var tabs_list = group.find(".tabs__list");
        var tab_headings = tabs_list.find(".panel__heading");
        var allTabs = tabs_list.find(".panel__title button");
        var tab_panel = "#" + tabLink.attr("aria-controls");
        var panels = group.find(".panel");

        tab_headings.removeClass("panel__heading--active");
        tabLink.closest(".panel__heading").addClass("panel__heading--active");

        // Update aria-selected and tabindex attributes
        allTabs.attr("aria-selected", "false").attr("tabindex", "-1");
        tabLink.attr("aria-selected", "true").attr("tabindex", "0");

        panels.removeClass("panel--active");
        $(tab_panel).parent().addClass("panel--active");

        // Update tabindex on panel content
        group.find(".panel__content").attr("tabindex", "-1");
        $(tab_panel).attr("tabindex", "0");

        tabLink.focus();
    }

    function initAccordions() {
        // iterate each accordion
        var accordions = $('[data-component="tabs"]');

        accordions.each(function () {
            // collapse all panels except for 1st panel
            var panel = $(this).find(".panel");

            panel.not(":eq(0)").addClass("panel--collapsed");

            // Set aria-selected to false for all accordion items
            // (aria-selected is only relevant for tabs, not accordions)
            // Wrap button in h3
            $(this).find(".panel__title button").each(function () {
                $(this).removeAttr("role").removeAttr("aria-selected").removeAttr("tabindex");
                if ($(this).parent().is(".panel__title")) {
                    $(this).wrap("<h3>");
                }
            });

            // Set aria-expanded based on collapsed state
            panel.not(":eq(0)").find(".panel__title button").attr("aria-expanded", "false");
            panel.eq(0).find(".panel__title button").attr("aria-expanded", "true");

            // activate panel when clicking title
            var panel_title = panel.find(".panel__title button");

            panel_title.unbind("click").click(function () {
                var $panel = $(this).closest(".panel");
                $panel.toggleClass("panel--collapsed");

                var isExpanded = !$panel.hasClass("panel--collapsed");
                $(this).attr("aria-expanded", isExpanded);

                return false;
            });
        });
    }

    function initTabs() {
        // iterate each tab group
        var tabs = $('[data-component="tabs"]');

        tabs.each(function () {
            // update our classes & setup our tab list
            var group = $(this);

            group.removeClass("panel-group--accordion");
            group.addClass("panel-group--tabs");

            // Unwrap h3 from buttons and restore tab attributes
            group.find(".panel__title h3 button").each(function () {
                $(this).attr("role", "tab").attr("aria-selected", "false").attr("tabindex", "-1");
                $(this).unwrap();
            });

            // populate our tab list — use div per spec (ul prevents accurate tab count in SRs)
            var tabs_list = $('<div class="tabs__list" role="tablist">');
            group.prepend(tabs_list);

            group.find(".panel__heading").appendTo(tabs_list);

            // Set aria-selected and tabindex on first tab
            var allTabs = tabs_list.find(".panel__title button");
            allTabs.attr("aria-selected", "false").attr("tabindex", "-1");
            tabs_list.find(".panel__heading:first-child .panel__title button").attr("aria-selected", "true").attr("tabindex", "0");
            tabs_list.find(".panel__heading:first-child").addClass("panel__heading--active");

            // setup our tab panels
            var panels = group.find(".panel");

            panels.wrapAll('<div class="tabs__content">');
            group.find(".panel:eq(0)").addClass("panel--active");

            // Make the active panel content focusable for keyboard users
            group.find(".panel__content").attr("tabindex", "-1");
            group.find(".panel:eq(0) .panel__content").attr("tabindex", "0");

            // activate tab when clicking tab list item
            var tab = tabs_list.find(".panel__title button");

            tab.click(function () {
                activateTab($(this));
                return false;
            });

            // Keyboard navigation for tabs
            tab.on("keydown", function (e) {
                var allTabLinks = $(this).closest(".tabs__list").find(".panel__title button");
                var currentIndex = allTabLinks.index(this);
                var newIndex;

                switch (e.key) {
                    case "ArrowRight":
                    case "ArrowDown":
                        e.preventDefault();
                        newIndex = (currentIndex + 1) % allTabLinks.length;
                        activateTab(allTabLinks.eq(newIndex));
                        break;
                    case "ArrowLeft":
                    case "ArrowUp":
                        e.preventDefault();
                        newIndex = (currentIndex - 1 + allTabLinks.length) % allTabLinks.length;
                        activateTab(allTabLinks.eq(newIndex));
                        break;
                    case "Home":
                        e.preventDefault();
                        activateTab(allTabLinks.eq(0));
                        break;
                    case "End":
                        e.preventDefault();
                        activateTab(allTabLinks.eq(allTabLinks.length - 1));
                        break;
                    case " ":
                        e.preventDefault();
                        activateTab($(this));
                        break;
                }
            });
        });
    }

    function destroyTabs() {
        // iterate each tab group
        var tabs = $('[data-component="tabs"]');

        tabs.each(function () {
            // update our classes & setup our tab list
            var group = $(this);

            group.removeClass("panel-group--tabs");
            group.addClass("panel-group--accordion");

            // iterate through each of our tab headings
            var tab_headings = group.find(".panel__heading");

            tab_headings.each(function () {
                // put our headings back with their panels
                var panel_id = $(this).find("button").attr("aria-controls");

                $(this).insertBefore($("#" + panel_id));
            });

            // Remove tab-specific attributes
            group.find(".panel__title button").removeAttr("tabindex").removeAttr("aria-selected");

            // unwrap the tab content container
            var panels = group.find(".panel");

            panels.unwrap();

            // remove the tab list container
            var tabs_list = group.find(".tabs__list");

            tabs_list.remove();
        });
    }

    $(document).ready(function () {
        // For mobile devices we'll start by displaying tabs
        // as accordions to keep the content optimized.
        enquire.register("screen and (max-width:959px)", {
            match: function () {
                initAccordions();
            },
        });

        // For laptops/desktops we'll then transform our pseudo
        // accordions into actual tabs since we have room now.
        enquire.register("screen and (min-width:960px)", {
            match: function () {
                initTabs();
            },
            unmatch: function () {
                destroyTabs();
                initAccordions(); // re-init accordion behavior after destroying tabs
            },
        });
    });
})(this);
